import Modal from "react-modal";
import useAppAccessor from "../../hooks/useappAccessor";
import { getBrandColor } from "../../utils/brand.util";
import useAppDispatch from "../../hooks/useAppDispatch";
import { postCheckout } from "../../services/shopcom.service";
import { languageMap } from "../../modules/interactions/components/interactionShoppingCart/map/language";
import { countryMap } from "../../modules/interactions/components/interactionShoppingCart/map/country";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    height: "auto",
    width: "90%",
    maxWidth: "480px",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    border: "none",
    outline: "none",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    borderRadius: 20,
    zIndex: 99999,
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4), 0 4px 16px rgba(0, 0, 0, 0.3)",
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24, 0.8)",
    backdropFilter: "blur(4px)",
    zIndex: 99999,
  },
};

const EndStreamModalHost = (props: any) => {
  const { getUserData, getLiveMainData, getInteractions } = useAppAccessor();
  const { language, client, referrer_user } = getUserData();
  const { joinWithAttendeeData } = getLiveMainData();
  const { productsInCart } = getInteractions();
  const dispatch = useAppDispatch();

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    // setIsOpen(false);
    // props.handleCloseMediaInteraction()
  }

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

  const brandColor = getBrandColor(client);

  const openNewTab = (url: string) => {
    // 检测是否为iOS设备
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    // 检测是否为移动设备
    const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent) || isIOS;

    if (isMobileDevice) {
      // 对于移动设备，直接打开链接
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      // 桌面浏览器使用a标签模拟点击
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      // 将a标签添加到文档中
      document.body.appendChild(link);

      // 模拟点击
      link.click();

      // 从文档中移除a标签
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    }
  };

  const transformLocale = (locale: string) => {
    if (locale === "en_US") {
      return "en";
    }
    return locale.replace(/_/g, "-");
  };

  // Tranont-specific checkout function
  const doTranontCheckOut = () => {
    let products: Array<any> = [];
    productsInCart.map((item: any) => {
      let options: Array<any> = [];
      options.push({ sku: item.options.sku });
      products.push({
        id: item.id.toString(),
        quantity: item.quantity,
        locale: item.locale,
        type: "PROD",
        nfr: item.nfr,
        userOptions: {
          appSourceId: "hussle",
        },
        option: options,
      });
    });

    // Construct the URL — locale path only when not default US English
    const cartLocale = products[0]?.locale;
    const baseUrl =
      cartLocale && cartLocale !== "en-US" && cartLocale !== "en_US"
        ? `https://www.tranont.com/${transformLocale(cartLocale)}/shop?bag=`
        : "https://www.tranont.com/?bag=";
    const productStrings = products
      .map((product) => {
        return `o:${product.id}:${product.option[0].sku}:${product.quantity}`;
      })
      .join("_");

    let shareCode = "";

    if (referrer_user != null && referrer_user?.third_party_username) {
      shareCode = referrer_user!.third_party_username;
    } else if (
      joinWithAttendeeData != null &&
      joinWithAttendeeData!.issuer_metadata != null &&
      joinWithAttendeeData?.issuer_metadata?.third_party_username
    ) {
      shareCode = joinWithAttendeeData?.issuer_metadata?.third_party_username;
    }

    const checkoutUrl = `${baseUrl}${productStrings}${
      shareCode ? `&share=${shareCode}` : ""
    }${
      products.every((product: any) => product.nfr === true) ? '&nfr=1' : ''
    }`;

    console.log("Tranont checkoutUrl", checkoutUrl);
    openNewTab(checkoutUrl);
  };

  // Shop.com checkout function
  const doShopComCheckOut = () => {
    let products: Array<any> = [];
    productsInCart.map((item: any) => {
      let options: Array<any> = [];
      options.push({ optionStringValue: item.options.name });
      products.push({
        id: item.id.toString(),
        quantity: item.quantity,
        type: 'PROD',
        userOptions: {
          appSourceId: "hussle"
        },
        option: options
      })
    })
    
    // 生成随机的购物车ID
    const generateRandomString = () => {
      return Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
    }

    var hostData = localStorage.getItem("hostData");
    var data = hostData?.split('_');
    var lan = languageMap[data![0].toLowerCase() as keyof typeof languageMap] ?? "eng";
    var country = countryMap[data![1].toLowerCase() as keyof typeof countryMap] ?? "usa";
    var id = `amos_${generateRandomString()}_w_${country}_${country}_${lan}`;
    let body = {
      application: "amos",
      id: id,
      language: lan,
      product_country: country,
      shipping_country: country,
      site_type: "w",
      products: products,
    };

    postCheckout(body).then((response: any) => {
      var prefix = 'https://www.shop.com/';
      if (lan == 'eng' && country == 'usa') {
        prefix = 'https://www.shop.com/';
      } else if (lan == 'eng' && country == 'gbr') {
        prefix = 'http://uk.shop.com/';
      } else if (lan == 'eng' && country == 'can') {
        prefix = 'http://ca.shop.com/';
      } else if (lan == 'eng' && country == 'aus') {
        prefix = 'http://au.shop.com/';
      } else if (lan == 'chi' && country == 'twn') {
        prefix = 'http://tw.shop.com/';
      } else if (lan == 'chi' && country == 'hkg') {
        prefix = 'http://hk.shop.com/';
      } else if (lan == 'chi' && country == 'sgp') {
        prefix = 'http://sgzh.shop.com/';
      } else if (lan == 'ind' && country == 'idn') {
        prefix = 'http://id.shop.com/';
      } else if (lan == 'eng' && country == 'idn') {
        prefix = 'http://iden.shop.com/';
      } else if (lan == 'eng' && country == 'hkg') {
        prefix = 'http://hken.shop.com/';
      } else if (lan == 'eng' && country == 'sgp') {
        prefix = 'http://sg.shop.com/';
      } else if (lan == 'msa' && country == 'mys') {
        prefix = 'http://mybm.shop.com/';
      } else if (lan == 'eng' && country == 'mys') {
        prefix = 'http://my.shop.com/';
      } else if (lan == 'chi' && country == 'mys') {
        prefix = 'http://myzh.shop.com/';
      }

      if (referrer_user != null && referrer_user?.third_party_username) {
        const url = prefix + referrer_user!.third_party_username + '/nbts/ccn_cart.xhtml?shopping_id=' + id;
        openNewTab(url);
      } else if (joinWithAttendeeData != null && joinWithAttendeeData!.issuer_metadata != null && joinWithAttendeeData?.issuer_metadata?.third_party_username) {
        const url = prefix + joinWithAttendeeData?.issuer_metadata?.third_party_username + '/nbts/ccn_cart.xhtml?shopping_id=' + id;
        openNewTab(url);
      } else {
        const url = prefix + 'nbts/ccn_cart.xhtml?shopping_id=' + id;
        openNewTab(url);
      }
    });
  };

  const handleCheckoutClick = () => {
    if (productsInCart && productsInCart.length > 0) {
      // Check if client is Tranont and use appropriate checkout function
      if (client === "tranont") {
        console.log("Using Tranont checkout");
        doTranontCheckOut();
      } else {
        console.log("Using Shop.com checkout");
        doShopComCheckOut();
      }
    }
  };

  const hasUncheckoutItems = productsInCart && productsInCart.length > 0;

  const customStylesMobile = {
    content: {
      top: "auto",
      left: 0,
      right: 0,
      width: "100%",
      border: "none",
      outline: "none",
      bottom: 0,
      padding: 0,
      borderRadius: "24px 24px 0 0",
      boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.5), 0 -2px 8px rgba(0, 0, 0, 0.3)",
    },
    overlay: {
      backgroundColor: "rgba(24, 24, 24, 0.8)",
      backdropFilter: "blur(4px)",
      zIndex: 99999,
    },
  };

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={isMobile ? customStylesMobile : customStyles}
      contentLabel="End Stream Modal"
    >
      <div
        className="flex w-full items-center justify-center relative"
        style={{
          background: "linear-gradient(145deg, #2d2d2d 0%, #1a1a1a 100%)",
          minHeight: isMobile ? "auto" : "280px",
        }}
      >
        <div 
          className="absolute top-0 left-0 right-0 h-1 rounded-t-full"
          style={{ backgroundColor: brandColor }}
        />
        
        <div className="flex flex-col justify-center items-center px-8 py-8 w-full">
          <div className="mb-6 text-center">
            <h2 className="text-2xl font-semibold text-white mb-4 tracking-tight">
              {hasUncheckoutItems ? "Livestream Ended" : "Thank You!"}
            </h2>
            
            {hasUncheckoutItems ? (
              <p className="text-sm text-gray-300 leading-relaxed">
                The livestream is over, but you still have items in your cart — want to check out?{" "}
                <button
                  onClick={handleCheckoutClick}
                  className="transition-all duration-200 hover:opacity-80 font-semibold inline-block"
                  style={{ 
                    color: brandColor,
                    WebkitTapHighlightColor: 'transparent',
                  }}
                >
                  Click here.
                </button>
              </p>
            ) : (
              <p className="text-sm text-gray-300 leading-relaxed">
                The livestream has ended. Thank you for joining us!
              </p>
            )}
          </div>

          <div className="w-full max-w-xs">
            <button
              onClick={() => props.handleClickOnNo()}
              className="w-full px-6 py-3 rounded-xl text-white font-semibold transition-all duration-200 active:scale-95 shadow-lg"
              style={{ 
                backgroundColor: brandColor,
                boxShadow: `0 4px 12px ${brandColor}40`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = "0.9";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = `0 6px 16px ${brandColor}60`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = "1";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = `0 4px 12px ${brandColor}40`;
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EndStreamModalHost;
